import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import StaticPage from '../../components/StaticPage';

const faqs = [
    {
        q: 'How do I find creators for a campaign?',
        a: 'Use Search to browse and filter every creator by platform and content category, or use the AI Bot to describe what you\'re looking for and get a matched shortlist.',
    },
    {
        q: 'What is Live AI Search and how is it different from Search?',
        a: 'Search looks across creators already on The Creator Match. Live AI Search instead pulls fresh, ranked posts for a platform and category directly from the source, so it reflects what is happening right now rather than stored profile data.',
    },
    {
        q: 'How is pricing shown?',
        a: 'Creators set their own reel, story and live rates on their profile. Those rates appear on the creator card and on the full profile, so you know the cost before reaching out.',
    },
    {
        q: 'What do the badges on a creator card mean?',
        a: '"Top Creator" flags creators the platform has recognized for quality, and "Responds Fast" flags creators who typically reply quickly to outreach.',
    },
    {
        q: 'Do I sign up as a brand or a creator?',
        a: 'Both options are available from Sign Up. Brands get a brand profile and access to search, the AI Bot and Live AI Search; creators get a profile to list their platforms, rates and content categories.',
    },
    {
        q: 'Is my data secure?',
        a: 'See our Privacy Policy for details on what we collect and how it is used. In short: we only collect what is needed to run the platform and connect brands with creators.',
    },
];

export default function FAQPage() {
    return (
        <StaticPage title="FAQs" subtitle="Common questions about using The Creator Match.">
            {faqs.map((item) => (
                <Accordion key={item.q}>
                    <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />}>
                        <Typography fontWeight={600}>{item.q}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography color="text.secondary">{item.a}</Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </StaticPage>
    );
}
